<template>
    <v-dialog
      v-model="is_open"
      width="700"
      @click:outside="close_script_dialog"
    >
      <v-card
        :style="{
          position: 'relative'
        }"
        v-if="!is_tab_install_back"
      >
          <span
            :style="{
              display: 'block',
              width: '30px',
              height: '30px',
              lineHeight: '30px',
              position: 'absolute',
              top: '15px',
              right: '15px',
              cursor: 'pointer',
            }"
            @click="close_script_dialog"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </span>
          <v-card-title
            :style="{
              margin: '0 0 5px 0'
            }"
          >1. 安裝 Optimize99 代碼</v-card-title>
      
          <v-card-subtitle
            :style="{
              margin: '0px'
            }"
          >請將以下程式碼複製並貼入您網站的每個網頁中。</v-card-subtitle>

          <v-card-subtitle
            :style="{
              padding: '0px 24px 0px'
            }"
          >請將這段程式碼放在網頁最上方的 <b>&lt;head&gt;</b> 中：</v-card-subtitle>
          
          <div
            :style="{
              position: 'relative',
              overflowX: 'auto',
              maxWidth: '800px'
            }"
          >
            <v-textarea
              ref="head_script"
              :value="`<!-- Start Optimize99 -->\n<script>(function(w, d, o) {var script = document.createElement('script');script.src = '${envCdnSrc}';script.onload = function() {w['opt99'].initialize('${containerId}');};var head = document.getElementsByTagName('head')[0];head.appendChild(script);})(window, document, 'opt99');</script>\n<!-- End Optimize99 -->`"
              no-resize
              readonly
              outlined
              name="input-7-4"
              :style="{
                padding: '0px 24px 0px',
                borderColor: '#dadce0',
                borderRadius: '4px',
                height: 'auto',
                margin: '0',
                minHeight: '50px',
                verticalAlign: 'top',
                fontFamily: 'courier new,courier,monospace',
                fontSize: '12px',
                maxWidth: '800px',
                overflow: 'auto'
              }"
              color="primary"
            ></v-textarea>
            <button
              @click="copyToClipboardByParentMethod('head_script')"
              :style="{
                position: 'absolute',
                top: '15px',
                right: '40px',
                cursor: 'pointer',
              }"
            >
              <v-icon
              >
                mdi-clipboard-multiple-outline
              </v-icon>
            </button>
          </div>

          <v-card-title
          >
            2. 檢查安裝狀態
          </v-card-title>

          <v-card-text class="d-flex pb-0">
              <v-form 
                ref="url_form" 
                lazy-validation
                style="width:100%;" 
                @submit.prevent="checkInstall(containerId, url)"
              >
                <v-text-field
                  @input="url_error_message = ''"
                  outlined
                  placeholder="輸入網址檢查"
                  color="primary"
                  v-model="url"
                  :rules="[$utils.field_rules.validateUrlAndHost, $utils.field_rules.required]"
                  validate-on-blur
                  :error-messages="url_error_message"
                >
                </v-text-field>
              </v-form>
              <v-btn
                :disabled="url === ''"
                class="mt-3 ml-3"
                color="primary"
                @click="checkInstall(containerId, url)"
              >
                檢查
              </v-btn>
          </v-card-text>
          <v-card-text v-if="is_show_hint">
            <v-alert
              dense
              border="left"
              type="warning"
            >
              若網頁無任何提示，可能是瀏覽器快取導致沒有載入程式，請嘗試重新整理頁面
            </v-alert>
          </v-card-text>
        <v-snackbar v-model="snackbar" >已複製到剪貼簿</v-snackbar>
      </v-card>

      <v-card class="pb-5" v-else>
          <span
            :style="{
              display: 'block',
              width: '30px',
              height: '30px',
              lineHeight: '30px',
              position: 'absolute',
              top: '15px',
              right: '15px',
              cursor: 'pointer',
            }"
            @click="close_script_dialog"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </span>
          <v-card-text class="pt-5 pb-1">
            <svg class="pt-8" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
              <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
              <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
            </svg>
            
            <v-card-title
              class="mt-5 mb-1 justify-center"
            > 
            <span
              class="pr-1"
              style="color: #5b8fe8;"
            >
              {{container_name}}
            </span> 
             代碼安裝成功
            </v-card-title>
            <v-card-subtitle
              class="justify-center d-flex mb-0 pb-0"
            >馬上開始使用Optimize99的功能吧!
            </v-card-subtitle>
          </v-card-text>
          <v-card-actions
            class="d-flex justify-center mt-6 pt-0"
          >
            <v-btn
              class="white--text"
              color="primary"
              @click="close_script_dialog"
            >
              關閉視窗
            </v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import {
  apiInstalledContainerStatus,
  apiGetContainer
} from '@/api/optimize.js'

export default {
    props: {
      container_name: String,
      containerId: String,
      check_url: String,
    },
    // inject:['parentMethod','snackbar'],
    name: "InstallAbTestScriptDialog",
    data() {
        return {
          snackbar: this.snackbar,
          is_open: true,
          test: '',
          envCdnSrc: process.env.VUE_APP_OPT99_GTM_SCRIPT_CDN,
          url: '',
          url_error_message: '',
          is_tab_install_back: false,
          token: '',
          is_show_hint: false
        }
    },
    mounted: function(){
      console.log(process.env.VUE_APP_OPT99_GTM_SCRIPT_CDN);
      document.addEventListener("visibilitychange", this.tabListener);
    },
    destroyed: function(){
      document.removeEventListener("visibilitychange", this.tabListener);
    },
    computed: {
    },
    created() {
      if (this.check_url) {
        this.url = decodeURIComponent(this.check_url)
      }
    },
    methods: {
      async copyToClipboard(item, value) {
        try {
          let textToCopy;
          switch (item) {
            case "head_script":

              if (value !== undefined) {

                textToCopy = value
              } else {
                
                textToCopy = await this.$refs.head_script.value
              }
              
              break;

            case "body_script":

              if (value !== undefined) {
                textToCopy = value
              } else {
                textToCopy = await this.$refs.body_script.value;
              }
              
              break;

            case "token":
              textToCopy = await this.$refs.token.value;
              break;
            case "line_bot":
              textToCopy = await this.$refs.line_bot.value;
              break;
            default:
              textToCopy = '未知'
              break;
          }
          await navigator.clipboard.writeText(textToCopy);
          console.log('已複製到剪貼簿');
          this.snackbar = true
        } catch (err) {
          console.error('無法複製: ', err);
        }
      },
        copyToClipboardByParentMethod(text) {
            switch (text) {
              case "head_script":
                this.copyToClipboard(text, this.$refs.head_script.value)
                break;

              case "body_script":
                this.copyToClipboard(text,this.$refs.body_script.value)  
                break;

              default:
                
                break;
            }

        },
        close_script_dialog() {
          this.$emit('closeScriptDialog')
        },
        checkInstall: async function(container_id, domain){
          console.log('container_id', container_id)
          console.log('domain', domain)
          let form = this.$refs.url_form.validate()
          if (!form) {
            return
          }
          try {
            this.token = await apiInstalledContainerStatus(
              container_id, this.$route.params.org_id)
            console.log('token', this.token)
          } catch (error) {
            this.$root.vtoast.show({ 
              message: `取得容器token失敗，原因: ${ error.response ? (JSON.stringify(error.response)): error}`
            })
          }

          if (this.token === '') {
            return
          }

          try {
            let url = ''
            if (domain.includes('https://') ===false) {
              url = new URL(`https://${domain}`)
            }
            else {
              url = new URL(domain)
            }
            console.log(url)
            const randomUUID = uuidv4();
            url.searchParams.append('checkInstall', true);
            url.searchParams.append('token', this.token);
            url.searchParams.append('container_id', container_id)
            url.searchParams.append('uuid', randomUUID)
            
            window.open(url.href, '_blank')
          } catch (error) {
            console.log(error)
            this.url_error_message = '請輸入正確格式的網址'
          }
        },
        tabListener(){
          if (!document.hidden) {
            this.backToTab()
          }
        },
        async backToTab(){
          if (this.token === '') {
            return
          }
          let container_id = this.containerId
          let org_id = this.$route.params.org_id

          try {
            let result = await apiGetContainer(org_id, container_id)
            let container = result.data
            console.log('container', container)
            if (container.is_installed) {
              this.is_tab_install_back = true
              this.$emit('refreshContainerList')
            }
            else {
              this.is_show_hint = true
            }

          } catch (error) {
            console.log('取得container失敗',error)
          }
        }
    }
}
</script>

<style scoped>
  svg {
    width: 100px;
    display: block;
    margin: 0px auto 0;
  }
  .path {
    stroke-dasharray: 1000;
    stroke-dashoffset: 0;
  }
  .path.circle {
    -webkit-animation: dash .9s ease-in-out;
    animation: dash .9s ease-in-out;
  }

  .path.check {
    stroke-dashoffset: -100;
    -webkit-animation: dash-check .9s .35s ease-in-out forwards;
    animation: dash-check .9s .35s ease-in-out forwards;
  }

  div.v-input__slot{
    background-color: #f8f9fa !important;
  }
  .focus-blue{
    border-color: #409aff;
  }
@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}

@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
</style>